import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

const STORAGE_KEY = "moebus_privacy_notice_v1";

export default function CookieNotice() {
    const location = useLocation();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!localStorage.getItem(STORAGE_KEY)) {
            const t = setTimeout(() => setVisible(true), 1200);
            return () => clearTimeout(t);
        }
    }, []);

    if (!visible || location.pathname.startsWith("/admin")) return null;

    const dismiss = () => {
        localStorage.setItem(STORAGE_KEY, new Date().toISOString());
        setVisible(false);
    };

    return (
        <div
            data-testid="cookie-notice"
            className="fixed bottom-4 left-4 right-4 sm:right-auto sm:max-w-sm z-[60] bg-moebus-deep/95 backdrop-blur border border-white/15 rounded-xl p-4 shadow-2xl animate-in fade-in slide-in-from-bottom-4 duration-500"
        >
            <div className="flex items-start gap-3">
                <div className="w-9 h-9 rounded-lg bg-emerald-500/20 text-emerald-400 flex items-center justify-center flex-shrink-0">
                    <ShieldCheck size={18} />
                </div>
                <div>
                    <div className="text-sm font-semibold text-white">Datenschutz</div>
                    <p className="mt-1 text-xs text-slate-300 leading-relaxed">
                        Diese Website verwendet nur technisch notwendige Cookies – kein Tracking, keine Werbung.
                        Details in unserer{" "}
                        <Link
                            to="/datenschutz"
                            data-testid="cookie-notice-privacy-link"
                            className="text-emerald-400 hover:text-emerald-300 underline underline-offset-2"
                        >
                            Datenschutzerklärung
                        </Link>
                        .
                    </p>
                    <button
                        data-testid="cookie-notice-dismiss"
                        onClick={dismiss}
                        className="mt-3 inline-flex items-center px-4 py-1.5 rounded-full bg-emerald-500 hover:bg-emerald-400 text-moebus-deep text-xs font-semibold transition-colors"
                    >
                        Alles klar
                    </button>
                </div>
            </div>
        </div>
    );
}
